import { Flex } from "@chakra-ui/react"
import { Tab } from "../../../../common/types/global"
import { FhResponseData } from "../../../../common/types/search"
import AllFilters from "./AllFilters/AllFilters"
import MobileFilters from "./AllFilters/MobileFilters/MobileFilters"

type Props = {
  globalFilters: FhResponseData
  allSearchFilters: FhResponseData
  selectedTab: Tab
  breadcrumbFilters: FhResponseData
  showFiltersNoResultsView: boolean
  currentTabCount: number
  rid: string
}

const FiltersWrapper = ({
  globalFilters,
  allSearchFilters,
  selectedTab,
  breadcrumbFilters,
  showFiltersNoResultsView,
  currentTabCount,
  rid,
}: Props) => {
  return (
    <>
      <Flex
        as="section"
        flexWrap="wrap"
        width="100%"
        gap="4"
        display={{ base: "none", md: "flex" }}
        id="filters-wrapper"
      >
        <AllFilters
          globalFilters={globalFilters}
          allSearchFilters={allSearchFilters}
          breadcrumbFilters={breadcrumbFilters}
          selectedTab={selectedTab}
          showFiltersNoResultsView={showFiltersNoResultsView}
          currentTabCount={currentTabCount}
          rid={rid}
        />
      </Flex>
      <Flex as="section" flexWrap="wrap" width="100%" gap="4" display={{ base: "flex", md: "none" }}>
        <MobileFilters
          globalFilters={globalFilters}
          allSearchFilters={allSearchFilters}
          breadcrumbFilters={breadcrumbFilters}
          selectedTab={selectedTab}
          showFiltersNoResultsView={showFiltersNoResultsView}
          currentTabCount={currentTabCount}
          rid={rid}
        />
      </Flex>
    </>
  )
}

export default FiltersWrapper
